import React from "react";
import LotBitTable from "../table/LotBitTable";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";

function BidCollection() {
  const isTablet = useMediaQuery({ query: "(max-width: 610px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 530px)" });
  const isMobileSmall = useMediaQuery({ query: "(max-width: 460px)" });
  const navigate = useNavigate();
  return (
    <div className="mt-1">
      <span className="valign-wrapper" style={{ gap: "25px" }}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate("/bid-history")}
        >
          arrow_back
        </span>
        <h3>Your Bid Details</h3>
      </span>

      {/* bit dteials--------------->>>>>>> */}
      <div
        className={`cover white mb-1 flex ${
          isMobileSmall
            ? "column align-center textAlign-center gap-1"
            : "space-between"
        } `}
        style={{ padding: isTablet ? "2rem" : "2rem 4rem" }}
      >
        <div style={{ order: isMobileSmall && "2" }}>
          <h5 className="margin-0px">
            Auction ID:<span className="cercle-purple-text">DAC56565</span>
          </h5>

          <p
            className={`${
              isMobile ? "font-18px" : "font-16px"
            } cercle-purple-text`}
          >
            Infinite cercle Private limited
          </p>
          <p className="mt-1 grey-text font-16px">Date & Time</p>
          <p
            className={`${
              isMobile ? "font-18px" : "font-16px"
            } cercle-purple-text`}
          >
            04-04-2024 <span className="ml-2">12:00am to 04:00pm</span>
          </p>
        </div>
        <div className="mr-1" style={{ order: isMobileSmall && "1" }}>
          <button
            className="button-style red-text pointer"
            style={{
              padding: "8px 40px",
              border: "1px solid red",
              fontWeight: "600",
              marginBottom: "5px",
            }}
          >
            Live
          </button>
          <p>
            Ends in <span className="cercle-purple-text">5:38:32</span>
          </p>
        </div>
      </div>

      {/* bit table==========================>>>>>>>>>>>>>>>>> */}
      <div className={`cover white ${!isMobile && "p-2"}`}>
        <h3 className="flex justify-center">Your Lot’s</h3>
        <LotBitTable />
      </div>
    </div>
  );
}

export default BidCollection;
